import React, { useState } from 'react';
import './search.scss';
import { SearchOutlined } from '@ant-design/icons';

interface SearchComponentProps {
  placeholder?: string;
  searchButtonText?: string;
  onSearch: (query: string) => void;
}

export const SearchComponent: React.FC<SearchComponentProps> = ({
  placeholder = 'Search...',
  onSearch
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = () => {
    onSearch(searchQuery);
    console.log(searchQuery);
  };
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    console.log(searchQuery.length);
    if (event.key === 'Enter') {
      handleSearch();
    }
    if (event.key === 'Backspace' && searchQuery.length < 3) {
      onSearch('');
    }
  };

  function handleOnChange(e: React.ChangeEvent<HTMLInputElement>): void {
    setSearchQuery(e.target.value);
  }

  return (
    <div className="search-input-container">
      <div className="search-input-container-inner">
        <input
          type="text"
          className="search-input"
          placeholder={placeholder}
          value={searchQuery}
          onChange={e => handleOnChange(e)}
          onKeyDown={handleKeyPress}
        />
        <button className="search-button" onClick={handleSearch}>
          <SearchOutlined/>
        </button>
      </div>
    </div>
  );
};
